import { Spacer as NbSpacer } from 'native-base';

import { addWithConfig } from '../../utils';

export const Spacer = NbSpacer;

export default addWithConfig(Spacer);
